import { Tooltip, styled } from "@mui/material";


const LightTooltip = styled(Tooltip)(({theme}) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: theme.spacing(2),
  },
}));

export default LightTooltip;
